import link from "@/scripts/host";
import store from '@/store/index.js';
import handleError from "@/scripts/handleError.js";
import loggedIn from '@/scripts/logged.js';


export default {
  name: "RestOfTheList",
  props: [
    "arrayElements",
    "top",
    "actualPlay",
    "isPlaying",
    "indexOfStart",
    "listNumber",
    "listDivide",
    'special',
  ],
  data() {
    return {
      activeIcon: "play_circle_outline",
      showAll: false,
      numberOfVotesCast: null,
      numberOfUsedVotes: null,
      allVoted: [],
      waitingRoom: false,
      canVote: true,
      indexSocial: null,
      votedBefore: [],
      

    };
  },
  methods: {
    toggleSocialElement(elementIndex) {
      this.indexSocial = elementIndex;
    },
  
    
    addVote(songId, listItem) {
      if (localStorage.user || sessionStorage.user) {

        if (this.numberOfUsedVotes < this.numberOfVotesCast) {
          listItem.voteAdded = true;
          this.allVoted.push(songId);
          this.numberOfUsedVotes++;
        }
      } else {
        this.$store.dispatch("setModalType", "login");
        this.$store.dispatch("toggleLoginModal");
      }
    },
    removeVote(songId, listItem) {
      if (localStorage.user || sessionStorage.user) {
        let index = this.allVoted.indexOf(songId);
        if (index > -1) {
          this.allVoted.splice(index, 1);
          this.numberOfUsedVotes--;
          listItem.voteAdded = false;
        }
      } else {
        this.$store.dispatch(
          "setGenericModalText",
          "Musisz być zalogowany aby zagłosować."
        );
        this.$store.dispatch("setModalType", "genericModal");
      }
    },
    async sendAllVotes() {
      let token = await loggedIn();

      if (localStorage.user || sessionStorage.user) {
        if (this.numberOfUsedVotes <= this.numberOfVotesCast) {
        
          let myVote = {
            listId: this.$store.state.currentListId,
            songIds: this.allVoted
          };
          this.votedBefore = [...this.votedBefore, ...this.allVoted]
          if (myVote.songIds.length !== 0) {
          this.axios({
            method: "post",
            url: `${link.hostLink}Vote/Vote`,
            headers: { authorization: `bearer ${token}` },
            data: myVote
          }).then(() => {
            this.allVoted = [];
            this.$store.dispatch("toggleLoginModal");
            this.$store.dispatch(
              "setGenericModalText",
              "Dziękujemy za oddanie głosów."
            );
            this.$store.dispatch("setModalType", "genericModal");
          }).catch(function(error) {
            handleError(error.response);
          });
        }
        }
      } else {
        this.$store.dispatch(
          "setGenericModalText",
          "Musisz być zalogowany aby zagłosować."
        );
        this.$store.dispatch("setModalType", "genericModal");
      }
    },
    playMP3(mp3) {
      this.$emit("songURL", mp3);
    },
    goToArtistSite(id) {
      if (!this.$route.path.includes("artysta")) {
        this.$router.push(`/artysta/${id}`);
      }
    },
    goToSong(id) {
      if (!this.$route.path.includes(`/utwór/${id}`)) {
        this.$router.push(`/utwór/${id}`);
      }
    },
    showFirstElement(listItem) {
      return listItem.position != 1;
    },
    makeFacebookLink(id, title) {
      return `https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Flp3.polskieradio.pl%2Futwór%2F${id}%2F&quote=Zagłosowałem na ${title} w Liście Przebojów Trójki`;
    },
    showAllSongs() {
      this.showAll = true;
      this.showActualElement();
    },
    async getVotePossibility() {
      let token = await loggedIn();

      this.axios(
        `${link.hostLink}SongList/GetCurrentVotingListNumber?typeId=${this.listNumber}`
      ).then(response => {
        store.dispatch("setCurrentListId", response.data)
        if (localStorage.user || sessionStorage.user) {

          this.axios({
            method: "get",
            url: `${link.hostLink}Vote/GetVoteSummary?ListId=${response.data}`,
            headers: { authorization: `bearer ${token}` }
          })
            .then(responseData => {
              this.numberOfVotesCast =
                responseData.data.data.numberOfVotesCast +
                responseData.data.data.numberOfRemainingVotes;
              this.numberOfUsedVotes = responseData.data.data.numberOfVotesCast;
            })
            .catch(function(error) {
              handleError(error.response);
            });
        }
      });
    },
    showWaitingRoom(item, index) {
      if (index === this.arrayElements.length - 1) {
        const same = this;
        setTimeout(function() {
          if (same.$refs.waiting) {
            same.$refs.waiting.forEach((item, i) => {
              if (i > 0) {
                item.style.display = "none";
              }
            });
          }
        }, 0);
      }
      if (
        this.listDivide &&
        item.position - 1 === this.listDivide[0].numberOfSongs &&
        this.listNumber === "1" &&
        this.indexOfStart
      ) {
        return true;
      } else {
        return false;
      }
    },
    showLucky13(item, index) {
      if (index === this.arrayElements.length - 1) {
        const same = this;
        setTimeout(function() {
          if (same.$refs.lucky13) {
            same.$refs.lucky13.forEach((item, i) => {
              if (i > 0) {
                item.style.display = "none";
              }
            });
          }
        }, 0);
      }
      if (
        this.listDivide &&
        this.listDivide[2] &&
        item.position - 1 ===
          this.listDivide[0].numberOfSongs + this.listDivide[1].numberOfSongs &&
        this.listNumber === "1" &&
        this.indexOfStart
      ) {
        return true;
      } else {
        return false;
      }
    },
    searchForOverflows() {
      this.$refs.artistNames.forEach((artistName, index) => {
        if (
          artistName.clientWidth >
          this.$refs.contentContainers[index].clientWidth
        )
          artistName.classList.add("exceed");
      });
      this.$refs.songTitles.forEach((songTitle, index) => {
        if (
          songTitle.clientWidth >
          this.$refs.contentContainers[index].clientWidth
        )
          songTitle.classList.add("exceed");
      });
    }
  },
  computed: {
    songsList() {
      if (this.indexOfStart) {
        this.getVotePossibility();
        if (this.showAll) {
          return this.arrayElements;
        } else {
          let firstCoupleElement = this.arrayElements.filter(function(
            value,
            index
          ) {
            if (index < 5) {
              return value;
            }
          });
          return firstCoupleElement;
        }
      } else {
        return this.arrayElements;
      }
    }
  },
  mounted() {
    this.axios
      .get(`${link.hostLink}SongList/GetVotingInfo?typeId=${this.listNumber}`)
      .then(response => {
        this.canVote = response.data.isVotingActive;
      });
    if (!this.indexOfStart) {
      this.getVotePossibility();
    }

    this.searchForOverflows();
  },
  updated() {
    this.searchForOverflows();
  }
};
